import React from 'react';
import { useLocation } from 'react-router-dom';
import Navigation from '../../components/Navigation/Navigation';
import { cn } from '../../lib/utils';
import { getThemeClass } from '../../lib/theme';

interface MainLayoutProps {
  children: React.ReactNode;
}

export const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  return (
    <div className="min-h-screen bg-slate-50 print:min-h-0 print:h-auto print:overflow-visible">
      <nav className="print:hidden">  {/* Added print:hidden class */}
        <Navigation />
      </nav>
      <main className={cn(
        // Only add padding-top when not on home page
        !isHomePage && "pt-16",
        "print:overflow-visible print:min-h-0 print:h-auto",
        !isHomePage && "print:pt-0"
      )}>
        {children}
      </main>
      <footer className="bg-slate-900 text-slate-400 py-12 print:hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-center">&copy; {new Date().getFullYear()} Chintan Tank. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};